import styled from 'styled-components';

const CellWrapper = styled.div<{
  $left?: boolean;
  style?: object;
  $header?: boolean;
}>`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  text-align: center;
  position: relative;
  z-index: 1;
  white-space: nowrap;

  ${({ $header }) =>
    $header
      ? `
      align-items: flex-start;
      flex-flow: row;
      justify-content: flex-start;
  white-space: wrap;
  `
      : ``}

  ${({ $left }) =>
    $left
      ? `
    align-items: flex-start;
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
  `
      : ''}

  small {
    min-width: 30px;
    text-align: left;
  }
`;

export const SolventsCellWrapper = styled(CellWrapper)`
  //display: block !important;
  /* height: auto; */
  flex-wrap: wrap !important;
  text-align: center !important;
  line-height: 1;
  padding-bottom: 8px;
  padding-top: 8px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
`;

export default CellWrapper;
